import { ExecutorAccountMeta } from '/@/modules/estateaccount/models/meta/ExecutorAccountMeta';
import { BeneficiaryAccountMeta } from '/@/modules/estateaccount/models/meta/BeneficiaryAccountMeta';
import { ExecutorAndBeneficiaryAccountMeta } from '/@/modules/estateaccount/models/meta/ExecutorAndBeneficiaryAccountMeta';
import { ProfessionalAccountMeta } from '/@/modules/estateaccount/models/meta/ProfessionalAccountMeta';
import { PredefinedEstateRole } from '/@/modules/role/enums/PredefinedEstateRole';
import { PlannerAccountMeta } from '/@/modules/estateaccount/models/meta/PlannerAccountMeta';
import { EstateProfessionalAccountMeta } from '/@/modules/estateaccount/models/meta/EstateProfessionalAccountMeta';
import { DefaultAccountMeta } from '/@/modules/estateaccount/models/meta/DefaultAccountMeta';

export class EstateAccountMeta {
  static factory(roleId, model = {}) {
    switch (roleId) {
      case PredefinedEstateRole.ESTATE_PROFESSIONAL.id:
        return new EstateProfessionalAccountMeta(model);
      case PredefinedEstateRole.BENEFICIARY.id:
      case PredefinedEstateRole.DEPENDANT.id:
        return BeneficiaryAccountMeta.factory(model);
      case PredefinedEstateRole.EXECUTOR.id:
      case PredefinedEstateRole.EXECUTOR_PROFESSIONAL.id:
        return new ExecutorAccountMeta(model);
      case PredefinedEstateRole.EXECUTOR_AND_BENEFICIARY.id:
      case PredefinedEstateRole.EXECUTOR_AND_DEPENDANT.id:
        return ExecutorAndBeneficiaryAccountMeta.factory(model);
      case PredefinedEstateRole.PROFESSIONAL.id:
        return new ProfessionalAccountMeta(model);
      case PredefinedEstateRole.PLANNER.id:
        return new PlannerAccountMeta(model);
      case PredefinedEstateRole.DEFAULT.id:
        return new DefaultAccountMeta(model);
      default:
        return null;
    }
  }
}
